import React from "react";

const PlanCard = ({ plans, onKeyDown, className, onChange }) => {

  return (
    <fieldset
      className={
        className ? `subscriptionPlan ${className}` : "subscriptionPlan"
      }
      onKeyDown={onKeyDown}
    >
      <legend>Subscription plan</legend>

      <div className="w-full flex flex-1 flex-row gap-6 flex_new">
        {plans.map(
          (
            {
              checked,
              disabled,
              id,
              name,
              value,
              legend,
              cardHeading,
              commingSoon,
              planPrice,
              enterprisePlanPrice,
              duration,
              contactUsLink,
              current,
              ckeckIcon,
              ContactSalesBtn,
            },
            index
          ) => {
            return (
              <div key={index} className="w-full flex flex-1">
                <input
                  disabled={disabled}
                  type="radio"
                  id={id}
                  name={name}
                  value={value}
                  checked={checked}
                  onChange={onChange}
                />
                <label htmlFor={id} className="subscriptionPlan__inner">
                  {ckeckIcon && <span className="activePln" role="img" />}
                  <span className="subscriptionPlan__header">
                    {current && (
                      <span className="cs__badge">
                        Current Plan
                      </span>
                    )}
                    <span className="subscriptionPlan__header_heading">
                      {legend}
                    </span>
                    {!commingSoon && (
                      <span className="subscriptionPlan__header_text">
                        {cardHeading}
                      </span>
                    )}
                    {commingSoon && <span className="subscriptionPlan__header_text">Unlimited users</span>}
                  </span>
                  <span className="subscriptionPlan__content">
                    {!commingSoon && (
                      <>
                        <span className="bigtext">{planPrice}</span>
                        {current && <span className="bigtext">{enterprisePlanPrice}</span> }
                      </>
                    )}
                    {!commingSoon && <span>{duration}</span>}
                    {contactUsLink && (
                      <a
                        role="button"
                        target="_blank"
                        className="btn btn--md button--blue ms-3"
                        href={contactUsLink}
                      >
                        Contact us
                      </a>
                    )}
                    {!current && ContactSalesBtn}
                  </span>
                </label>
              </div>
            );
          }
        )}
      </div>
    </fieldset>
  );
};

export default PlanCard;
